import type { ModelConfig } from '@swf/core/store';

import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { QuickSwitcherState } from './types';

export const defaultState = Object.freeze({
  data: undefined,
  isLoading: false,
  isNavigating: false
}) satisfies QuickSwitcherState;

interface QuickSwitcherModel extends ModelConfig<QuickSwitcherState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

const quickSwitcher: QuickSwitcherModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export default quickSwitcher;
